// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"f7350db5","327":"611befa3"}[chunkId] + ".chunk.js";
};